import React, { Component } from 'react';
import $ from 'jquery';
import { connect } from 'react-redux';
import Spinner from '../Spinner/Spinner';
import { Editor } from "@tinymce/tinymce-react";
import '../noteBookContainer/noteBookContainer.css';
import { handleException } from "../../app/util/util";
import loaderColors1 from '../Spinner/loaderColors1.gif';
import sectionIcon from '../noteBookContainer/sectionIcon.png';
import { setUserDetails, increment, setLabelVOList, setRemovedLabelVOList, setLabelSettingsVOList, setCustomOutlineTitle } from '../../app/redux/UserSlice';
export class CustomNoteContainer extends Component {
    constructor(props) {
        super(props);
        this.editorRef = props.editorRef ? props.editorRef : React.createRef();
        this.customeNoteLabel = React.createRef();
        const { bookVO, userVO } = this.props;
        this.state = {
            loading: false,
            saveLoading: false,
            bookVO: bookVO,
            userVO: userVO,
            annotationId: "",
            saveBtnChanges: "",
            customAnnoationId: null,
            customAnnotationText: "",
            errorInvalideClassCodeMsg: "",
            customOutlineId: this.props.customOutlineId,
            customNoteTitle: this.props.customNoteTitle,
            showTitleLabel: this.props.customOutlineId ? true : false,
            keepMeLogIn: localStorage.getItem('keepLoggedIn') ? "true" : "false"
        }
        this.handleCreateNoteLink = this.handleCreateNoteLink.bind(this);
        this.saveCustomOutlineNote = this.saveCustomOutlineNote.bind(this);
    }
    componentDidUpdate = (prevProps, prevState) => {
        if (this.props.customOutlineId &&
            this.props.customOutlineId !== "" &&
            this.props.customOutlineId !== prevProps.customOutlineId) {
            if (this.props.customOutlineId != '-999') {
                this.getCustomOutlineContent(this.props.customOutlineId)
            } else {
                this.customeNoteLabel.current.value = ""
                if (this.editorRef.current && this.editorRef.current.getBody())
                    this.editorRef.current.getBody().innerHTML = ""
                this.setState({
                    "showTitleLabel": false,
                    "customAnnotationText": "",
                    "customNoteTitle": "",
                    "customOutlineId": null,
                    "customAnnoationId": null
                })
            }
        }
    }
    componentWillUnmount() { this.stopInterval(); }
    startInterval() {
        this.interval = setInterval(() => {
            if (this.editorRef.current.getBody().textContent.trim().length > 1) {
                this.saveCustomOutlineNote(false);
            }
        }, 15000);
    }
    stopInterval() {
        clearInterval(this.interval);
        this.interval = 0;
    }
    getCustomOutlineContent() {
        this.setState({ "customOutlineId": this.props.customOutlineId, "customNoteTitle": this.props.customNoteTitle, "loading": true })
        let reqData = {
            "userVO": {
                "userId": this.state.userVO.userId,
                "userRole": this.state.userVO.userRole,
                "userRoleId": this.state.userVO.userRoleId,
                "userActivityVO": {
                    "lastReadBookId": this.props.bookVO.bookId,
                    "lastReadSubSectionId": "subsec01",
                    "lastReadParagraphId": "para01",
                    "lastActivityCode": "BOOKSHELF",
                    "pageNavigatingFrom": "CASES",
                    "pageNavigatingTo": "CASES"
                },
                "sessionVO": {
                    "appType": "web",
                    "deviceType": localStorage.getItem('deviceType'),
                    "deviceOS": localStorage.getItem('deviceOS'),
                    "deviceMacId": "",
                    "keepMeLoggedInFlag": this.state.keepMeLogIn,
                    "browserName": localStorage.getItem('browserName'),
                    "sessionAuthenticationToken": this.state.userVO.sessionAuthenticationToken
                }
            },
            "annotationVO": {
                "bookId": this.props.bookVO.bookId,
                "customOutlineId": this.props.customOutlineId
            }
        }
        const requestOptions1 = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify(reqData)
        };
        fetch(localStorage.getItem('ENV') + "/manageOutlineService/getAnnotationsForCustomOutline", requestOptions1)
            .then(response => response.json())
            .then(data => {
                if (data.status === "true") {
                    if (data) {
                        var customTitle = ""
                        if (this.props.currUserVO.customOutlineTitle) {
                            for (var i = 0; i < this.props.currUserVO.customOutlineTitle.length; i++) {
                                if (this.props.currUserVO.customOutlineTitle[i].chapterId === this.props.customOutlineId) {
                                    customTitle = this.props.currUserVO.customOutlineTitle[i].chapterTitle
                                    break;
                                }
                            }
                        }
                        this.customeNoteLabel.current.value = customTitle
                        this.setState({
                            "customAnnotationText": data.annotationVOList ?
                                data.annotationVOList.customAnnotationText ? data.annotationVOList.customAnnotationText : " " : " ",
                            "showTitleLabel": true,
                            "customNoteTitle": customTitle,
                            "customAnnoationId": data.annotationVOList ? data.annotationVOList.annotationId : null,
                            "loading": false,
                            "errorInvalideClassCodeMsg": ""
                        })
                    }
                } else {
                    if (data.wkErrorCode) {
                        handleException(data);
                    }
                }
            }).catch(error => {
                console.error("There has been a problem with your fetch operation:", error);
                this.setState({ "loading": false })
            });
    }
    handleEditorChange = (e) => {
        e.stopPropagation();
        if (e.target.getContent().length > 15) {
            this.saveCustomOutlineNote(false);
        }
    }
    handleEditorOnBlur = (e) => {
        e.stopPropagation();
        this.stopInterval();
    }
    changeSaveButtonColour = (e) => {
        if (document.getElementById("customNoteSaveButton") !== null) {
            document.getElementById("customNoteSaveButton").classList.add("customNoteSaveButtonColour");
            document.getElementById("customNoteSaveButton").parentElement.setAttribute("style", "background-color: #007ac3 !important");
        }
        if (document.getElementById("mobileSaveButton") !== null) {
            document.getElementById("mobileSaveButton").disabled = false;
        }
        if (this.interval == 0 || this.interval == undefined) {
            this.startInterval();
        }
    }
    handleCreateNoteLink = (e) => {
        e.target.setAttribute("customOutlineId", null)
        this.customeNoteLabel.current.value = ""
        if (this.editorRef.current && this.editorRef.current.getBody())
            this.editorRef.current.getBody().innerHTML = ""
        this.props.onAddCustomOuline("-999", "");
        this.setState({
            "showTitleLabel": false,
            "customAnnotationText": "",
            "customNoteTitle": "",
            "customOutlineId": null,
            "customAnnoationId": null
        })
    }
    handleCusomtTitleOnBlur = (e) => {
        let customTitleTxt = document.getElementById("txtCustomNote")
        let customeTitle = this.customeNoteLabel.current.value
        if (customeTitle && customeTitle.trim().length > 0) {
            this.setState({ "saveLoading": true })
            let reqData = {
                "userVO": {
                    "userId": this.state.userVO.userId,
                    "userRole": this.state.userVO.userRole,
                    "userRoleId": this.state.userVO.userRoleId,
                    "userActivityVO": {
                        "lastViewedOutlineId": "",
                        "lastReadParagraphId": "para01",
                        "lastActivityCode": "BOOKSHELF",
                        "pageNavigatingTo": "BOOKSHELF",
                        "pageNavigatingFrom": "BOOKSHELF",
                        "lastReadSubSectionId": "subsec01",
                        "lastViewedOutlineType": "customOutline",
                        "lastViewedCustomOutlineTitle": customTitleTxt && customTitleTxt.value
                    },
                    "sessionVO": {
                        "appType": "web",
                        "deviceMacId": "",
                        "deviceOS": localStorage.getItem('deviceOS'),
                        "keepMeLoggedInFlag": this.state.keepMeLogIn,
                        "deviceType": localStorage.getItem('deviceType'),
                        "browserName": localStorage.getItem('browserName'),
                        "sessionAuthenticationToken": this.state.userVO.sessionAuthenticationToken
                    }
                },
                "outlineVO": {
                    "bookId": this.props.bookVO.bookId,
                    "userCustomOutlineTitle": customeTitle.trim(),
                    "customOutlineId": this.state.customOutlineId ? this.state.customOutlineId : "-999"
                }
            }
            const requestOptions1 = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify(reqData)
            };
            fetch(localStorage.getItem('ENV') + "/manageOutlineService/saveCustomOutlineTitle", requestOptions1)
                .then(response => response.json())
                .then(data => {
                    if (data) {
                        if (data.status === "true") {
                            var updatedCustomLabel = []
                            if ((!this.state.customOutlineId || isNaN(this.state.customOutlineId))) {
                                var temp = this.props.currUserVO.customOutlineTitle
                                var temp2 = JSON.parse(JSON.stringify(temp))
                                reqData.outlineVO.chapterId = data.outlineVO.customOutlineId
                                reqData.outlineVO.chapterTitle = customeTitle
                                temp2.push(reqData.outlineVO)
                                updatedCustomLabel = temp2
                            } else {
                                var existingOutlineTitle = this.props.currUserVO.customOutlineTitle
                                for (var i = 0; i < existingOutlineTitle.length; i++) {
                                    if (existingOutlineTitle[i].chapterId === this.state.customOutlineId) {
                                        var temp = JSON.parse(JSON.stringify(existingOutlineTitle[i]))
                                        temp.chapterTitle = customeTitle
                                        updatedCustomLabel.push(temp)
                                    } else {
                                        updatedCustomLabel.push(existingOutlineTitle[i])
                                    }
                                }
                            }
                            if (updatedCustomLabel !== undefined &&
                                updatedCustomLabel.find(elm => elm.chapterId === '-999') === undefined) {
                                let i = Object.create(updatedCustomLabel);
                                i.chapterId = '-999';
                                i.chapterTitle = '';
                                i.lastModifiedTimestamp = '';
                                i.outlineType = '';
                                updatedCustomLabel.unshift(i);
                            }
                            this.props.setCustomOutlineTitle(updatedCustomLabel);
                            this.props.onAddCustomOuline(data.outlineVO.customOutlineId, customeTitle);
                            this.setState({
                                "showTitleLabel": true,
                                "customNoteTitle": customeTitle,
                                "saveLoading": false,
                                "customOutlineId": data.outlineVO.customOutlineId,
                                "errorInvalideClassCodeMsg": ""
                            })
                            customTitleTxt.setAttribute("customOutlineId", data.outlineVO.customOutlineId)
                        } else {
                            if (data.httpErrorCode === "400" && data.wkErrorCode === "bus.exception.duplicate.custom.outline.title") {
                                this.setState({ "saveLoading": false, "errorInvalideClassCodeMsg": "You already have a note with this name. Please try a different name for this note." })
                            } else {
                                if (data.wkErrorCode) {
                                    handleException(data);
                                }
                            }
                        }
                    }
                }).catch(error => {
                    console.error("There has been a problem with your fetch operation:", error);
                    this.setState({ "saveLoading": false })
                    if (error) {
                        if (error.wkErrorCode && error.wkErrorCode === "bus.exception.duplicate.custom.outline.title")
                            this.setState({ "saveLoading": false, "errorInvalideClassCodeMsg": "You already have a note with this name. Please try a different name for this note." })
                    }
                });
        }
    }
    saveCustomOutlineNote = (showLoading = true) => {
        this.setState({ "saveBtnChanges": "Content Typed in the Notepad Editor Saved Successfully" });
        if (showLoading) { this.stopInterval(); }
        this.setState({ "saveLoading": showLoading });
        if (document.getElementById("customNoteSaveButton") !== null) {
            document.getElementById("customNoteSaveButton").classList.remove("customNoteSaveButtonColour");
            document.getElementById("customNoteSaveButton").parentElement.removeAttribute("style");
        }
        if (document.getElementById("mobileSaveButton") !== null) {
            document.getElementById("mobileSaveButton").disabled = true;
        }
        if (this.state.customOutlineId && !isNaN(this.state.customOutlineId)) {
            let reqData = {
                "userVO": {
                    "userId": this.state.userVO.userId,
                    "userRole": this.state.userVO.userRole,
                    "userRoleId": this.state.userVO.userRoleId,
                    "userActivityVO": {
                        "lastViewedOutlineId": "",
                        "pageNavigatingTo": "Outline",
                        "lastReadParagraphId": "para01",
                        "lastActivityCode": "BOOKSHELF",
                        "pageNavigatingFrom": "Outline",
                        "lastReadSubSectionId": "subsec01",
                        "lastReadBookId": this.props.bookVO.bookId,
                    },
                    "sessionVO": {
                        "appType": "web",
                        "deviceMacId": "",
                        "deviceOS": localStorage.getItem('deviceOS'),
                        "keepMeLoggedInFlag": this.state.keepMeLogIn,
                        "deviceType": localStorage.getItem('deviceType'),
                        "browserName": localStorage.getItem('browserName'),
                        "sessionAuthenticationToken": this.state.userVO.sessionAuthenticationToken
                    }
                },
                "annotationVOList": [
                    {
                        "highlightEndOffset": -999,
                        "highlightStartOffset": -999,
                        "customAnnotationFlag": "true",
                        "bookId": this.props.bookVO.bookId,
                        "customOutlineId": this.state.customOutlineId,
                        "userCustomOutlineTitle": this.state.customNoteTitle,
                        "customAnnotationText": this.editorRef.current.getBody().innerHTML,
                        "annotationUpdateStatus": "createCustomAnnotationFromCustomOutline"
                    }
                ]
            }
            if (this.state.customAnnoationId) {
                reqData.annotationVOList[0].annotationUpdateStatus = "modifyCustomAnnotationFromCustomOutline"
                reqData.annotationVOList[0].annotationId = this.state.customAnnoationId
            }
            const requestOptions1 = {
                method: 'POST',
                body: JSON.stringify(reqData),
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            };
            fetch(localStorage.getItem('ENV') + "/manageOutlineService/saveCustomOutLine", requestOptions1)
                .then(response => response.json())
                .then(data => {
                    if (data.status === "true" && data.annotationVOList) {
                        this.setState({ "customAnnoationId": data.annotationVOList.annotationId, "saveLoading": false, "saveBtnChanges": "" });
                    } else if (data.wkErrorCode) {
                        handleException(data);
                    }
                }).catch(error => {
                    console.error("There has been a problem with your fetch operation:", error);
                    this.setState({ "saveLoading": false, "saveBtnChanges": "" });
                });
        } else {
            if ((this.editorRef.current.getContent({ format: "text" })).length > 0) {
                let customTitle = (this.editorRef.current.getContent({ format: "text" })).substring(0, 25);
                let reqData = {
                    "userVO": {
                        "userId": this.state.userVO.userId,
                        "userRole": this.state.userVO.userRole,
                        "userRoleId": this.state.userVO.userRoleId,
                        "userActivityVO": {
                            "lastViewedOutlineId": "",
                            "lastReadParagraphId": "para01",
                            "lastActivityCode": "BOOKSHELF",
                            "pageNavigatingTo": "BOOKSHELF",
                            "pageNavigatingFrom": "BOOKSHELF",
                            "lastReadSubSectionId": "subsec01",
                            "lastViewedOutlineType": "customOutline",
                            "lastViewedCustomOutlineTitle": customTitle
                        },
                        "sessionVO": {
                            "appType": "web",
                            "deviceMacId": "",
                            "keepMeLoggedInFlag": this.state.keepMeLogIn,
                            "deviceOS": localStorage.getItem('deviceOS'),
                            "deviceType": localStorage.getItem('deviceType'),
                            "browserName": localStorage.getItem('browserName'),
                            "sessionAuthenticationToken": this.state.userVO.sessionAuthenticationToken
                        }
                    },
                    "outlineVO": {
                        "customOutlineId": "-999",
                        "bookId": this.props.bookVO.bookId,
                        "userCustomOutlineTitle": customTitle.trim(),
                    }
                }
                const requestOptions1 = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                    body: JSON.stringify(reqData)
                };
                fetch(localStorage.getItem('ENV') + "/manageOutlineService/saveCustomOutlineTitle", requestOptions1)
                    .then(response => response.json())
                    .then(data => {
                        if (data) {
                            if (data.status === "true") {
                                this.setState({
                                    "showTitleLabel": true, "customNoteTitle": customTitle,
                                    "customOutlineId": data.outlineVO.customOutlineId, "errorInvalideClassCodeMsg": ""
                                })
                                this.customeNoteLabel.current.value = customTitle.trim()
                                var updatedCustomLabel = []
                                var temp = this.props.currUserVO.customOutlineTitle
                                var temp2 = JSON.parse(JSON.stringify(temp))
                                reqData.outlineVO.chapterId = data.outlineVO.customOutlineId
                                reqData.outlineVO.chapterTitle = customTitle.trim()
                                temp2.unshift(reqData.outlineVO)
                                updatedCustomLabel = temp2
                                this.props.setCustomOutlineTitle(updatedCustomLabel);
                                let reqData2 = {
                                    "userVO": {
                                        "userId": this.state.userVO.userId,
                                        "userRole": this.state.userVO.userRole,
                                        "userRoleId": this.state.userVO.userRoleId,
                                        "userActivityVO": {
                                            "lastViewedOutlineId": "",
                                            "pageNavigatingTo": "Outline",
                                            "lastReadParagraphId": "para01",
                                            "pageNavigatingFrom": "Outline",
                                            "lastActivityCode": "BOOKSHELF",
                                            "lastReadSubSectionId": "subsec01",
                                            "lastReadBookId": this.props.bookVO.bookId,
                                        },
                                        "sessionVO": {
                                            "appType": "web",
                                            "deviceMacId": "",
                                            "deviceOS": localStorage.getItem('deviceOS'),
                                            "keepMeLoggedInFlag": this.state.keepMeLogIn,
                                            "deviceType": localStorage.getItem('deviceType'),
                                            "browserName": localStorage.getItem('browserName'),
                                            "sessionAuthenticationToken": this.state.userVO.sessionAuthenticationToken
                                        }
                                    },
                                    "annotationVOList": [
                                        {
                                            "highlightEndOffset": -999,
                                            "highlightStartOffset": -999,
                                            "customAnnotationFlag": "true",
                                            "bookId": this.props.bookVO.bookId,
                                            "customOutlineId": this.state.customOutlineId,
                                            "userCustomOutlineTitle": this.state.customNoteTitle,
                                            "customAnnotationText": this.editorRef.current.getBody().innerHTML,
                                            "annotationUpdateStatus": "createCustomAnnotationFromCustomOutline"
                                        }
                                    ]
                                }
                                const requestOptions2 = {
                                    method: 'POST',
                                    body: JSON.stringify(reqData2),
                                    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                                };
                                fetch(localStorage.getItem('ENV') + "/manageOutlineService/saveCustomOutLine", requestOptions2)
                                    .then(response => response.json())
                                    .then(data => {
                                        if (data.status === "true" && data.annotationVOList) {
                                            this.setState({ "customAnnoationId": data.annotationVOList.annotationId, "saveLoading": false, "saveBtnChanges": "" });
                                        } else if (data.wkErrorCode) {
                                            handleException(data);
                                        }
                                    }).catch(error => {
                                        console.error("There has been a problem with your fetch operation:", error);
                                        this.setState({ "saveLoading": false, "saveBtnChanges": "" })
                                    });
                            } else {
                                if (data.httpErrorCode === "400" && data.wkErrorCode === "bus.exception.duplicate.custom.outline.title") {
                                    this.setState({ "saveLoading": false, "errorInvalideClassCodeMsg": "You already have a note with this name. Please try a different name for this note." })
                                } else if (data.wkErrorCode) {
                                    handleException(data);
                                }
                            }
                        }
                    }).catch(error => {
                        console.error("There has been a problem with your fetch operation:", error);
                        if (error) {
                            if (error.wkErrorCode && error.wkErrorCode === "bus.exception.duplicate.custom.outline.title")
                                this.setState({ "errorInvalideClassCodeMsg": "You already have a note with this name. Please try a different name for this note." })
                        } else
                            this.setState({ "loading": false })
                    });
            }
        }
    }

    handleCustomTitleOnEnter = (e) => {
        if (e.key === 'Enter') {
            this.handleCusomtTitleOnBlur(e);
        }
    }
    handleSaveCustomOutline = (e) => {
        if (e.key === 'Enter') {
            this.saveCustomOutlineNote(e);
        }
    }
    saveCustomOutlineNoteTest = () => { this.saveCustomOutlineNote() }
    render() {
        let log = () => {
            this.saveCustomOutlineNoteTest()
        }
        // 47051 - A11Y: Add a New Note link is not inert when its function is disabled
        const isAddNewNoteInert = !this.state.customOutlineId || this.state.customOutlineId === "-999";
        return (
            <div id="customeNoteContainer">
                <Spinner
                    loading={this.state.loading || this.state.saveLoading}
                    imageSrc={loaderColors1}
                    overlayBackground="rgba(0,0,0,0.5)"
                    label={this.state.saveLoading ? "Saving your note" : "Loading your note"}
                />
                <div className="mTopTen">
                    {/* 47051 - A11Y: Add a New Note link is not inert when its function is disabled */}
                    {/* Original:
                    <a href="javascript:void(0)" id="addNewNote" onClick={this.handleCreateNoteLink}>
                        <span className="addNewNote_rt">Add a New Note</span>
                    </a> */}
                    {/* 47051 - A11Y: Add a New Note link is not inert when its function is disabled (React 17 needs inert as a string) */}
                    <a href="javascript:void(0)" id="addNewNote" onClick={this.handleCreateNoteLink} inert={isAddNewNoteInert ? "" : undefined}>
                        <span className="addNewNote_rt">Add a New Note</span>
                    </a>
                </div>
                <input data-testid="noteTitle" id="txtCustomNote" aria-label="Enter Note Title" placeholder="Enter Note Title" defaultValue={this.state.customNoteTitle} ref={this.customeNoteLabel}
                    className="mTopTen" onBlur={this.handleCusomtTitleOnBlur} key="txtCustomNote"></input>
                <div data-testid="invalidClassCodeMessage" className="error-colorCode">{this.state.errorInvalideClassCodeMsg}</div>
                <Editor onInit={(evt, editor) => this.editorRef.current = editor} apiKey="0pf9aw3is77mhjeluerke3yzvxj13f9yocjczeumortsxfg5"
                    init={{
                        selector: "textarea", theme: 'silver',
                        mobile: {
                            theme: 'silver',
                            plugins: ["autosave", "lists", "autolink"],
                            toolbar: "undo redo bold italic bullist numlist outdent indent styleselect"
                        },
                        plugins: "lists fullscreen template directionality noneditable advlist nonbreaking help",
                        help_accessibility: true,
                        toolbar1: "undo redo | fontselect fontsizeselect | bold italic underline | alignleft aligncenter alignright alignjustify | sectionButton | bullist numlist | outdent indent | forecolor backcolor | help",
                        toolbar2: "saveButton", menubar: false, directionality: "ltr", toolbar_items_size: 'medium', extended_valid_elements: "a[href|onclick]",
                        fontsize_formats: "10px 12px 14px 18px 24px 36px 48px 64px",
                        font_formats:
                            "Andale Mono=andale mono,times;" +
                            "Arial=arial,helvetica,sans-serif;" +
                            "Arial Black=arial black,avant garde;" +
                            "Book Antiqua=book antiqua,palatino;" +
                            "Comic Sans MS=comic sans ms,sans-serif;" +
                            "Courier New=courier new,courier;" +
                            "Georgia=georgia,palatino;" +
                            "Helvetica=helvetica;" +
                            "Impact=impact,chicago",
                        entity_encoding: "named", resize: "true", statusbar: false, height: 380, marginBottom: 10,
                        nonbreaking_force_tab: false, toolbar: "ltr rtl  bullist numlist", forced_root_block: 'p',
                        force_br_newlines: false, force_p_newlines: true, paste_auto_cleanup_on_paste: false,
                        setup: function (editor) {
                            editor.on('init', function () { $('[aria-label="Save"]').attr('id', 'customNoteSaveButton') });
                            editor.ui.registry.addButton('sectionButton', {
                                text: '<image title="Section Symbol" src=' + sectionIcon + ' />', tooltip: 'Section Symbol',
                                onAction: function (_) {
                                    editor.focus();
                                    editor.selection.setContent('&sect;');
                                }
                            });
                            editor.ui.registry.addButton('saveButton', {
                                text: 'Save', tooltip: 'Save',
                                onAction: function (e1) { log() }
                            });
                        }
                    }}
                    aria-label="Rich Text Editor" initialValue={this.state.customAnnotationText}
                    onChange={this.handleEditorChange} onKeyUp={this.changeSaveButtonColour} onBlur={this.handleEditorOnBlur}
                />
                <div data-testid="save" onClick={this.saveCustomOutlineNote} tabIndex="0" onKeyDown={(e) => this.handleSaveCustomOutline(e)}>
                    <input type="submit" value="Save" id="mobileSaveButton" className="customMobileNoteSaveButton" disabled />
                </div>
                <div data-testid="saveMessage" aria-live="assertive" aria-relevant="additions text" style={{ position: 'absolute', left: '-9999px' }}>{this.state.saveBtnChanges}</div>
            </div>
        )
    }
}
const mapDispatchToProps = () => {
    return {
        setUserDetails: setUserDetails,
        increment: increment,
        setLabelVOList: setLabelVOList,
        setRemovedLabelVOList: setRemovedLabelVOList,
        setLabelSettingsVOList: setLabelSettingsVOList,
        setCustomOutlineTitle: setCustomOutlineTitle
    }
}
const mapStateToProps = state => ({ currUserVO: state.userVO });
export default connect(mapStateToProps, mapDispatchToProps())(CustomNoteContainer);
